function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.65 13a1.43 1.43 0 00-1.5 1.35v3.58a4.85 4.85 0 010 .66A2 2 0 0122 19c-.06.13-.13.26-.2.38l-.25.26a2.39 2.39 0 01-.34.21 3.17 3.17 0 01-.41.12H4.53L4.2 20a3.31 3.31 0 01-.42-.12 4.05 4.05 0 01-.35-.21l-.24-.26A3.47 3.47 0 013 19a3.54 3.54 0 01-.11-.44 4.42 4.42 0 010-.63V14.5A1.48 1.48 0 001.42 13 1.48 1.48 0 000 14.5v3.43a7.85 7.85 0 000 .84 6 6 0 00.14.85 5.73 5.73 0 00.3.82 4.5 4.5 0 00.72 1.11 4.22 4.22 0 002.21 1.33 5.76 5.76 0 001.46.12h15.6a4.44 4.44 0 002.48-.68 4.24 4.24 0 001-.86 6.08 6.08 0 00.47-.66 6.2 6.2 0 00.36-.79 4.87 4.87 0 00.26-1.73V14.5a1.42 1.42 0 00-1.35-1.5z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.48 7.58L11 5.06v10.53a1.5 1.5 0 003 0V5.06l.35.35 2.17 2.17a1.46 1.46 0 002.06-2.06l-2.93-2.93L13.8.73a1.77 1.77 0 00-.16-.22.47.47 0 01-.06-.09h-.07a1.51 1.51 0 00-.35-.23h-.1a1.3 1.3 0 00-.49-.19h-.14a1.3 1.3 0 00-.49.09h-.1a1.51 1.51 0 00-.35.23h-.07a1.64 1.64 0 00-.2.26L8.59 3.35 6.42 5.52a1.46 1.46 0 002.06 2.06z"
});

function SvgUpload(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 25.01 23"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "assets/images/upload.5789511f.svg";
export { SvgUpload as ReactComponent };